import React from "react";
import { useNavigate } from "react-router-dom";

export default function Logout() {
  const navigate = useNavigate();

  const handleLogout = async () => {
    const serverFolder = localStorage.getItem("server_folder");
    const serverUrl = localStorage.getItem("server_url");
    const company_id = localStorage.getItem("company_id");
    const company_header_logo = localStorage.getItem("company_header_logo");

    localStorage.clear();
    // Keep server configuration
    if (serverFolder)
      localStorage.setItem(
        "server_folder",
        serverFolder ? serverFolder : "/build_v1"
      );
    let server_folder = localStorage.getItem("server_folder");

    if (serverUrl)
      localStorage.setItem(
        "server_url",
        serverUrl ? serverUrl : server_folder + "/../v1/"
      );
    if (company_id)
      localStorage.setItem("company_id", company_id ? company_id : "2");
    if (company_header_logo)
      localStorage.setItem("company_header_logo", company_header_logo);

    navigate("/login");
  };

  React.useEffect(() => {
    handleLogout();
  }, []);

  return <></>;
}
